import { Link } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import { StripeEmbeddedCheckout } from "@/components/stripe-embedded-checkout";
import {
  EARLY_BIRD_DISCOUNT_CODE,
  EARLY_BIRD_DISCOUNT_LABEL,
} from "@/lib/cohorts";
import { useSEO } from "@/lib/use-seo";

const PREMIUM_PRICE_ID = "premium_lifetime";

const BULLETS = [
  "One-time payment of $1,400",
  `${EARLY_BIRD_DISCOUNT_LABEL} with code ${EARLY_BIRD_DISCOUNT_CODE}`,
  "Lifetime access to live cohorts",
  "Coaching and VIP community",
  "No subscription to manage",
];

const PremiumCheckout = () => {
  useSEO({
    title: "Checkout — Premium Membership",
    description:
      "Complete your Premium Membership purchase for AI for HR Mastermind. One-time payment of $1,400.",
    path: "/checkout/premium",
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-background pt-28 pb-16">
      <div className="section-inner max-w-3xl">
        <Link
          to="/membership"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to membership
        </Link>

        <div className="mb-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-3">
            Premium Membership
          </h1>
          <p className="text-muted-foreground">
            Lifetime access to live cohorts, coaching, and the VIP community.
          </p>
        </div>

        {/* Plan summary */}
        <div className="rounded-xl border-2 border-primary bg-primary/5 p-5 mb-8 shadow-sm">
          <div className="flex items-start justify-between gap-2 mb-2">
            <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Pay in full
            </span>
          </div>
          <p className="mb-3 rounded-lg bg-secondary/10 px-3 py-2 text-sm font-medium text-secondary">
            {EARLY_BIRD_DISCOUNT_LABEL}. Code{" "}
            <span className="font-bold text-foreground">
              {EARLY_BIRD_DISCOUNT_CODE}
            </span>
            .
          </p>
          <div className="mb-3">
            <span className="text-2xl font-bold">$1,400</span>
            <span className="text-sm text-muted-foreground ml-1">
              one-time payment
            </span>
          </div>
          <ul className="space-y-1.5">
            {BULLETS.map((b) => (
              <li
                key={b}
                className="flex items-start gap-2 text-sm text-foreground/80"
              >
                <Check className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-card border border-border rounded-xl overflow-hidden shadow-sm">
          <StripeEmbeddedCheckout priceId={PREMIUM_PRICE_ID} />
        </div>
      </div>
    </div>
  );
};

export default PremiumCheckout;
